import BackNavigationButton from "@/src/components/ui-kit/back-navigation";
import ScButton from "@/src/components/ui-kit/button";
import InputField from "@/src/components/ui-kit/input-field.rhf";
import { useForgotPassword } from "@/src/hooks/features/auth/use-forgot-password";
import { useTheme } from "@/src/styles/theme-provider";
import { Image, Pressable, ScrollView, Text, View } from "react-native";

export default function ForgotPassword() {
  const { varStyle } = useTheme();
  const {
    control,
    handleSubmit,
    errors,
    isSubmitting,
    onSubmit,
    navigateToRegistration,
    t,
  } = useForgotPassword();

  return (
    <View style={varStyle} className="flex-1 bg-chalk web:flex-row">
      <View className="hidden xl:flex flex-1 items-end justify-center p-8">
        <Image
          source={require("../../../assets/images/Forgot_password.png")}
          className="w-full h-full max-w-xl"
          resizeMode="contain"
        />
      </View>

      <View className="flex-1 items-center justify-center web:px-6 py-4">
        <ScrollView
          className="w-full"
          contentContainerClassName="items-start justify-center min-h-full"
          showsVerticalScrollIndicator={false}
        >
          <View className="w-full max-w-lg px-4 py-0">
            <View className="rounded-xl border border-ash-3 bg-chalk p-6 web:p-5">
              <BackNavigationButton
                labelClassName="text-onyx"
                iconClassName="text-onyx"
                to="/(auth)/login"
              />

              <View className="flex-row justify-center items-center mt-6 mb-4 web:mt-6 web:mb-3">
                <Image
                  source={require("@/src/assets/images/club_logo.png")}
                  style={{ width: 28, height: 28 }}
                  resizeMode="contain"
                />
                <Text className="ml-2 text-primary text-2xl font-bold">
                  {t("LABEL_SELISE_LOGO")}
                </Text>
              </View>

              <Text className="web:text-xl text-2xl font-bold text-center mb-2 web:mb-1 text-onyx">
                {t("QUEST_FORGOT_YOUR_PASSWORD")}
              </Text>
              <Text className="web:text-xs text-sm text-center text-slate mb-6 web:mb-4">
                {t("HINT_ENTER_EMAIL_BELOW")}
              </Text>

              <InputField
                showLabel
                label={t("LABEL_EMAIL")}
                control={control}
                name="email"
                placeholder={t("LABEL_EMAIL_PLACEHOLDER")}
                backgroundColor="bg-obsidian"
                keyboardType="email-address"
                error={errors.email?.message}
                returnKeyType="go"
                onSubmitEditing={handleSubmit(onSubmit)}
              />

              <Pressable
                disabled={isSubmitting}
                onPress={handleSubmit(onSubmit)}
                className={`bg-primary py-3 rounded-lg justify-center mb-6 h-16 web:h-10 web:mb-4 hover:opacity-90 ${isSubmitting ? "opacity-70" : ""}`}
              >
                <Text className="text-white text-center font-semibold">
                  {isSubmitting ? t("BTN_SUBMITTING") : t("BTN_CONFIRM")}
                </Text>
              </Pressable>
            </View>

            <View className="mt-12 items-center mb-6 web:mt-4 web:mb-2">
              <Image
                source={require("../../../assets/images/selise_logo.png")}
                style={{ width: 100, height: 36 }}
                resizeMode="contain"
              />
            </View>
          </View>
        </ScrollView>
      </View>
    </View>
  );
}
